@if (_showItems) {
  <div class="show font-5 fw-bold uppercase" [ngClass]="{ mobile: mobile }">
    <span>Show:</span>
    <div class="show__container">
      @if (selectedShow) {
        <span
          [class.is-active-dropdown]="showActive"
          class="show__trigger font-2"
          (click)="toggleShow()"
        >
          <span class="sort__trigger--label">
            {{ selectedShow.label }}
          </span>
        </span>
      }
      <span
        class="show__dropdown"
        [class.active]="showActive"
        [class.left]="position === 'left'"
        [class.right]="position === 'right'"
      >
        @for (item of _showItems; track item) {
          <label
            class="products-list__filters__parent custom-control custom-radio font-5"
          >
            <input
              value="{{ item.name }}"
              name="show"
              class="custom-control-input radio-dark-gray"
              type="radio"
              (change)="updateSelected(item)"
              [checked]="item.selected"
            />
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{ item.label }}</span>
          </label>
        }
      </span>
    </div>
    @if (canShowExport) {
      <div class="ms-3">
        <button
          class="btn btn-icon large with-border with-shadow background-white me-2"
          title="Export to Excel"
          (click)="exportToExcel()"
        >
          <i class="fal fa-file-excel"></i>
        </button>
        <button
          class="btn btn-icon large with-border with-shadow background-white"
          title="Export to PDF"
          (click)="exportToPDF()"
        >
          <i class="fal fa-file-pdf"></i>
        </button>
      </div>
    }
  </div>
}
